import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import {EmailChangedModalDispatchProps} from '../types/containers';
import EmailChangedModalView from '../components/views/EmailChangedModalView';
import * as MenuActions from '../../creditoReal/actions/mx/MenuActions';
import {menuSelector} from '../../creditoReal/selectors/ui/menu';
import * as MenuConstants from '../constants/MenuConstants';
import {LoanApplicationMenuState, MediciValidationState} from '../../creditoReal/types/mx/reducers';
import {MODAL_TYPE} from '../../../constants/ModalConstants';

const mapStateToProps = (state: State) => {
    const menu = menuSelector(state);
    const menuMediciValidations: LoanApplicationMenuState = menu.find(menu => menu.id === MenuConstants.CHANGE_STATUS_LOG);
    const mediciValidation: MediciValidationState = state.creditoReal.loan.loanApplication.mediciValidation;
    const hasMediciValidations = mediciValidation ? mediciValidation.validations.length > 0 : false;
    return {
        hasMediciValidations,
        menuMedici: menuMediciValidations
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): EmailChangedModalDispatchProps => {
    return {
        onPressClose: (menu, hasMediciValidations) => () => {
            const header = {
                title: 'Enviar email',
                closeBtn: true
            };
            const content = {
                type: MODAL_TYPE.MEDICI_VALIDATIONS_AGAIN_EMAIL_SENT,
                data: {}
            };
            const options = {
                closeOnOverlayClick: false,
                size: 'small'
            };
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
            dispatch(MenuActions.ON_CHANGE_MAIN_MENU_ITEM.action(menu));
            if (hasMediciValidations)
                dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(header, content, null, options));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onPressClose: dispatchProps.onPressClose(stateProps.menuMedici, stateProps.hasMediciValidations),
    };
};

const EmailChangedModalContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(EmailChangedModalView);

export default EmailChangedModalContainer;
